import {Construtor} from './construtor';
import {Usuario} from './usuario';

export class ComentarioOcorrencia implements Construtor<ComentarioOcorrencia> {

  public idComentarioOcorrencia: number;
  public idOcorrencia: number;
  public usuario: Usuario;
  public comentario: string;
  public dataComentario: Date;

  constructor(object?: any) {
    this.usuario = new Usuario();
    if (object !== undefined) {
      if (object instanceof (ComentarioOcorrencia)) {
        this.copyObject(object);
      } else if (object instanceof Usuario) {
        this.usuario = new Usuario(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
  }

  set IdComentarioOcorrencia(id: any) {
    this.idComentarioOcorrencia = id;
  }

  set Usuario(usuario: any) {
    this.usuario = usuario;
  }

  set IdOcorrencia(id: any) {
    this.idOcorrencia = id;
  }

  set Comentario(comentario: any) {
    this.comentario = comentario;
  }

  set DataComentario(dataComentario: any) {
    this.dataComentario = dataComentario;
  }

  parseFromJson(comentarioOcorrencia: any): void {
    this.IdComentarioOcorrencia = comentarioOcorrencia.idComentarioOcorrencia;
    this.Usuario = comentarioOcorrencia.usuario;
    this.IdOcorrencia = comentarioOcorrencia.idOcorrencia;
    this.Comentario = comentarioOcorrencia.comentario;
    this.DataComentario = comentarioOcorrencia.dataComentario;
  }

  copyObject(comentarioOcorrencia: ComentarioOcorrencia): void {
    this.idComentarioOcorrencia = comentarioOcorrencia.idComentarioOcorrencia;
    this.usuario = comentarioOcorrencia.usuario;
    this.idOcorrencia = comentarioOcorrencia.idOcorrencia;
    this.comentario = comentarioOcorrencia.comentario;
    this.dataComentario = comentarioOcorrencia.dataComentario;
  }

  modeloCompleto(): boolean {
    return this.idOcorrencia !== undefined && this.usuario !== undefined && this.comentario !== undefined
      && this.dataComentario !== undefined;
  }

  getNewInstance(object?: any): ComentarioOcorrencia {
    return new ComentarioOcorrencia(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/comentario-ocorrencia.ts